jQuery(document).ready(function ($) {

    // Hero Swiper
    var swiper = new Swiper('.hero', {
        observer: true,
        observeParents: true,
        autoplay: {
            delay: 7000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        speed: 1500,
        allowTouchMove: false,
        preloadImages: false,
        lazy: {
            loadPrevNext: true,
        },
		loop: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
    });

	var videoSwiper = new Swiper(".video-slider.swiper-container", {
		slidesPerView: 1,
		navigation: {
			nextEl: ".video-slider .swiper-button-next",
			prevEl: ".video-slider .swiper-button-prev",
		},
		pagination: {
			el: ".video-slider .swiper-pagination",
			clickable: true,
			renderBullet: function (index, className) {
			  return '<span class="' + className + '">' + (index + 1) + "</span>";
			},
		},
    });

    var lectureSwiper = new Swiper(".lecture-slider.swiper-container", {
        autoHeight: true,
        spaceBetween: 30,
        speed: 500,
        pagination: {
            el: ".lecture-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".lecture-swiper-button-next",
            prevEl: ".lecture-swiper-button-prev",
        },
        keyboard: {
            enabled: true,
            onlyInViewport: false,
            pageUpDown: false,
        },
    });

});
